import { useState, useCallback } from 'react';
import dayjs from 'dayjs';

export default function useDateRange(searchInfo) {
  const [startDate, setStartDate] = useState(searchInfo.startDate);
  const [endDate, setEndDate] = useState(searchInfo.endDate);

  // 시작일 변경
  const handleStartDateChange = useCallback(
    (newStart) => {
      const newStartDate = dayjs(newStart).format('YYYY-MM-DD');

      // 최신 종료일을 ref에서 가져오기
      let updatedEnd = searchInfo.endDate;

      // 시작일이 종료일보다 크거나 같으면 종료일도 시작일로 맞춤
      if (!dayjs(newStartDate).isBefore(dayjs(updatedEnd))) {
        updatedEnd = newStartDate;
      }

      // state 업데이트
      setStartDate(newStartDate);
      setEndDate(updatedEnd);

      // ref도 최종 값으로 갱신
      searchInfo = {
        ...searchInfo,
        startDate: newStartDate,
        endDate: updatedEnd,
      };
    },
    [searchInfo]
  );

  // 종료일 변경
  const handleEndDateChange = useCallback(
    (newEnd) => {
      const newEndDate = dayjs(newEnd).format('YYYY-MM-DD');

      // 최신 시작일을 ref에서 가져오기
      let updatedStart = searchInfo.startDate;

      // 종료일이 시작일보다 빠르면 시작일을 종료일로 맞춤
      if (dayjs(newEndDate).isBefore(dayjs(updatedStart))) {
        updatedStart = newEndDate;
      }

      // state 업데이트
      setStartDate(updatedStart);
      setEndDate(newEndDate);

      // ref도 최종 값으로 갱신
      searchInfo = {
        ...searchInfo,
        startDate: updatedStart,
        endDate: newEndDate,
      };
    },
    [searchInfo]
  );

  return {
    startDate,
    endDate,
    handleStartDateChange,
    handleEndDateChange,
  };
}
